module.exports = __webpack_public_path__ + "img/m-bg-banner.7b5d5c05.png";